import React, { useEffect } from 'react';
import { getMenuPath, escapeHtml } from '../utils/bannerUtils';

/**
 * 센터 이미지 - 메뉴 JSON 데이터 기반 동적 생성 (그리드 시스템용)
 * 원본: center-image-dynamic fragment
 *
 * @param {string} title - 페이지 타이틀
 * @param {Array} breadcrumbPath - breadcrumb 경로 배열
 * @param {string} leftImg - 좌측 이미지 경로
 * @param {string} rightImg - 우측 이미지 경로
 */
const CenterImageDynamic = ({ title, breadcrumbPath, leftImg = '', rightImg = '' }) => {
  useEffect(() => {
    // AOS 초기화
    if (typeof window.AOS !== 'undefined') {
      requestAnimationFrame(() => {
        window.AOS.refreshHard();
      });
    }
  }, []);

  const pageTitle = title || '페이지';
  const finalLeftImg = leftImg || '/assets/images/page/left_slide.png';
  const finalRightImg = rightImg || '/assets/images/page/right_slide.png';
  const title1Value = pageTitle || 'view page';
  const title2Final = getMenuPath(breadcrumbPath);

  return (
    <>
      <link rel="stylesheet" href="/assets/css/page/center-image/main-image-title.css" />
      <div>
        <div className="breadcrumb-area bg-gray-4 breadcrumb-padding-1">
          <div className="container" id="main-center-text2" data-aos="fade-up" data-aos-delay="200" style={{ position: 'relative', zIndex: 2 }}>
            <div className="breadcrumb-content text-center aos-init aos-animate">
              <h2 className="aos-init aos-animate" id="content-tree-text">{escapeHtml(title1Value)}</h2>
              <ul className="aos-init aos-animate" id="content-tree-ul">
                <li>{title2Final}</li>
              </ul>
            </div>
          </div>
          {/* 좌측 이미지 */}
          <div className="breadcrumb-img-1 aos-init aos-animate">
            <img
              src={escapeHtml(finalLeftImg)}
              alt=""
              data-aos="fade-right"
              data-aos-delay="200"
              style={{ aspectRatio: '300 / 250', objectFit: 'contain', objectPosition: 'left bottom' }}
            />
          </div>
          {/* 우측 이미지 */}
          <div className="breadcrumb-img-2 aos-init aos-animate">
            <img
              src={escapeHtml(finalRightImg)}
              alt=""
              data-aos="fade-left"
              data-aos-delay="200"
              style={{ aspectRatio: '300 / 250', objectFit: 'contain', objectPosition: 'right bottom' }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CenterImageDynamic;

